module.exports = __webpack_public_path__ + "zilla-slab-latin-500italic.3abcca87ccbb95fc2c36056b34bb1170.woff";